import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PreloginService } from '../../services/prelogin.service';
import { Router } from '@angular/router';
import { ValidationsService } from '../../services/common/validations.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private router: Router, private validationService: ValidationsService, private preLoginService: PreloginService) { }

  // flag is set to true on button click, and is does not indicates that form has been submitted
  isForgotPasswordFormSubmitted = false;

  // Forms
  forgotPasswordForm: FormGroup;

  userNotExists = false;
  isErroredOut = false;
  isPasswordLinkSent = false;

  ngOnInit() {
    // redirect already logged in user to dashboard
    if (localStorage.getItem('pp_session') != null) {
      this.router.navigate(['/my-dashboard']);
    }

    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, this.validationService.validateEmail]]
    });
  }

  // getters
  get email() { return this.forgotPasswordForm.get('email'); }

  // Form submit
  forgotPasswordFormSubmit() {

    this.isForgotPasswordFormSubmitted = true;

    if (this.forgotPasswordForm.invalid) {
      return;
    }
    console.log('valid');
    this.isPasswordLinkSent = true;
    // this.preLoginService.login(this.forgotPasswordForm.value).subscribe(data => {
    //   if (data.statusCode == 404 && data.status == false) {
    //     this.userNotExists = data.message;
    //   }
    //   else if (data.statusCode == 500 && data.status == false) {
    //     this.isErroredOut = data.message;
    //   }
    //   else {
    // this.forgotPasswordForm.reset();
    // this.isForgotPasswordFormSubmitted = false;
    //   }
    // });
  }

}
